import { render } from "./admin-leave.vue?vue&type=template&id=2789a93a&scoped=true"
import script from "./admin-leave.vue?vue&type=script&lang=js"
export * from "./admin-leave.vue?vue&type=script&lang=js"

import "./admin-leave.vue?vue&type=style&index=0&id=2789a93a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2789a93a"]])

export default __exports__